
import TextEvent = createjs.TextEvent;
import { TextField } from "@goodgamestudios/createjs-utilities";
import { TextFieldType, TextFormat, TextFormatAlign, ColorTransform } from "@goodgamestudios/createjs-utilities";
import {getLogger} from "@goodgamestudios/logger";
import {TEXT_FIELDS_LOGGER} from "../../../index";
const logger = getLogger(TEXT_FIELDS_LOGGER + ".TextFieldHelper");

export class TextFieldHelper {


    /**
     * Färbt den Text eines Textfelds einfach um (setzt TextFormat und defaultTextFormat neu).
     *
     * @param txt:TextField
     * @param color:uint
     * */
    public static recolorTextField(txt: TextField, color: string | number, firstIndex: number = -1, lastIndex: number = -1): void {
        let textFormat: TextFormat = txt.getTextFormat();
        textFormat.color = ColorTransform.colorNumToString(color);
        txt.setTextFormat(textFormat, firstIndex, lastIndex);
        txt.defaultTextFormat = textFormat;
    }

    /**
     * Ändert die Schriftgröße des Textfeldes bis der Text in der angegbenen Zeilenanzahl hineinpasst
     * @deprecated "Do not use this. If text does not fit, ask either game design or loca for new texts/translations"
     * @param size:any
     * @param textField:TextField
     * @param text:String
     * @param numLines:int
     *
     */
    //[Deprecated(message="Do not use this. If text does not fit, ask either game design or loca for new texts/translations")]
    public static changeTextFromatSizeByTextWidth(size: any, textField: TextField, text: string, numLines: number = 1): number {
        let cache = (textField as any)._fontSizeCache = (textField as any)._fontSizeCache || new Map<string, number>();
        if (numLines === 1 && text.length < 50 && cache.get(text)) {
            textField.text = text;
            return textField.getTextFormat().size = cache.get(text);
        }
        textField.getTextFormat().size = size;
        textField.multiline = true;
        textField.wordWrap = true;
        textField.text = text;

        //if  text field is wordwrapped/multiline and there are more lines than allowed - shrink it!
        while (textField.numLines > numLines && textField.getTextFormat().size > 6) {
            TextFieldHelper.shrinkText(textField);
        }
        let finalSize = textField.getTextFormat().size;
        if (numLines === 1 && text.length < 50 && finalSize > 6) {
            cache.set(text, finalSize);
        }
        return finalSize;
    }

    /**
     *   Reduces the size of the TextFormat.size
     *   invoked recursively until the text fits nicely according to (height, width or numlines)
     * @deprecated "Do not use this. If text does not fit, ask either game design or loca for new texts/translations"
     * @param textField
     * @param format
     */
    public static shrinkText(textField: TextField): void {
        // TODO @HTML5  absolutely check performance of this functionality that is called recursively for textfields..
        textField.getTextFormat().size -= 1;
        (textField as any).invalidate(`font size reduced`);
    }

    /**
     * Ändert die Schriftgröße des Textfeldes bis der Text in der angegbenen Maximalhöhe hineinpasst
     * @deprecated "Do not use this. If text does not fit, ask either game design or loca for new texts/translations"
     * @param size:any
     * @param textField:TextField
     * @param text:String
     *
     */
    //		[Deprecated(message="Do not use this. If text does not fit, ask either game design or loca for new texts/translations")]
    public static changeTextFromatSizeByMaxHeight(size: any, textField: TextField, text: string): void {
        let maxHeight: number = textField.height;
        textField.getTextFormat().size = size;
        textField.multiline = true;
        textField.wordWrap = true;
        textField.text = text;

        while (textField.textHeight > maxHeight && textField.getTextFormat().size > 6) {
            TextFieldHelper.shrinkText(textField);
        }
    }

    /**
     *    Setzt einen Einzeiligen Text in einem Zweizeiligen Textfeld in die Mitte
     *
     *  @param textField:TextField
     *  @param basicLeading:Number
     *
     */
    public static changeSingleLineTextVerticalAlignInMultiLineTextfield(textField: TextField, basicLeading: number = 0): void {
        let value: string = textField.text;
        let format: TextFormat = textField.defaultTextFormat;
        format.leading = basicLeading;
        textField.defaultTextFormat = format;
        textField.setTextFormat(format);

        if (textField.numLines == 1) {
            textField.text = " \n" + value;
            format.leading = 0 - Number(format.size) / 2;
            textField.defaultTextFormat = format;
            textField.setTextFormat(format);
        }
    }

    /**
     *    Setzt einen Mehrzeiligen Text in einen Mehrzeiligen Textfeld solala in die Mitte ;)
     *
     *    @param textField:TextField
     *
     */
    public static changeTextFieldVerticalAllignByLinesNumber(textField: TextField, maxLines: number = 1): void {
        if (textField.numLines < maxLines) {
            // TODO: @HTML5 - call getMeasuredHeight instead
            // http://createjs.com/docs/easeljs/classes/Text.html#method_getMeasuredHeight
            logger.warn("TODO: @HTML5 - changeTextFieldVerticalAllignByLinesNumber");

            // let lineM: TextLineMetrics = textField.getLineMetrics(0);
            // let textFieldOriginalHeight: number = textField.height;
            //
            // textField.height = textField.textHeight + lineM.descent;
            // textField.y += (textFieldOriginalHeight - textField.height) * .5;
        }

    }

    public static changeVerticalAlignInMultiLineTextfield(textField: TextField): void {
        let value: string = textField.text;
        let format: TextFormat = textField.defaultTextFormat;
        let freeVerticalTextSpace: number = textField.height - (textField.textHeight + Number(format.leading));

        if (freeVerticalTextSpace < 0) {
            return;
        }
        let addLines: number = Math.floor((freeVerticalTextSpace / (Number(format.size) + Number(format.leading))) / 2);

        for (let i: number = 0; i < addLines; i++) {
            textField.text = " \n" + value;
            value = textField.text;
        }
    }

    /**
     *
     *  Trims a textfield adding ellipses at the ende of truncated text
     * kürzt einen zu langen Text an der optimalen Stelle und fügt "dot dot dot" an
     *
     * @param textField:TextField
     *
     */
    public static sliceTextAnAddPoints(textField: TextField): void {
        let pointStr: string = "...";
        //TextWeite
        let textLength: number = textField.textWidth;
        //reduziere maxLength um je 2px Gutter auf jeder Seite
        let maxLength: number = textField.width - 4;

        if (textLength > maxLength) {
            let wordList: any[] = textField.text.split(" ");
            let newStr: string = "";
            textField.text = "";

            for (let strPart of wordList) {
                // APPENDS each word and ellipses to the textfield     (needed for widht calculation)
                textField.appendText(strPart + " " + pointStr);
                // if textwidth is still smaller than max - remove the ellipses from the text field
                // // add the current word to the new textstring and go on with the loop
                if (textField.textWidth < maxLength) {
                    newStr += strPart + " ";
                    textField.text = textField.text.slice(0, textField.text.indexOf(pointStr));
                }
                else {
                    break;
                }
            }
            // adds ellipses to new textstring and pass it to the textfield
            newStr += pointStr;
            textField.text = newStr;
        }

    }

    /**
     *    params1:    value
     *    params2:    "one" String
     *    params3:    "more then one" String
     *    return:        String with value
     */
    public static generateStringByValue(value: number, oneString: string, moreString: string): string {
        let result: string;

        if (value > 1) {
            result = value + " " + moreString;
        }
        else {
            result = value + " " + oneString;
        }

        return result;

    }

    public static changeInputDirection(inputTextField: TextField, language: string): void {
        if (inputTextField.type != TextFieldType.INPUT) {
            return;
        }
        let tf: TextFormat = inputTextField.defaultTextFormat;

        switch (language) {
            case "ar":
                tf.align = TextFormatAlign.RIGHT;
                inputTextField.addEventListener(TextEvent.TEXT_INPUT, this.bindFunction(TextFieldHelper.onTextInput));
                break;
            default:
                tf.align = TextFormatAlign.LEFT;
                if (inputTextField.hasEventListener(TextEvent.TEXT_INPUT)) {
                    inputTextField.removeEventListener(TextEvent.TEXT_INPUT, this.bindFunction(TextFieldHelper.onTextInput));
                }
                break;
        }
        inputTextField.defaultTextFormat = tf;
    }

    private static onTextInput(event: TextEvent): void {
        // // change writing direction from left --> right to right --> left
        // let a: any[] = TextFieldHelper.calcBiDiDisplay(event.target.text, "", 1000);
        // let textField: TextField = (<TextField>event.target);
        // let result: string = "";
        //
        // while (a[0].segments.length > 0) {
        //     result += a[0].segments.pop();
        // }
        // let leftFromCursor: string = textField.text.slice(0, textField.caretIndex);
        // let rightFromCursor: string = textField.text.slice(textField.caretIndex, textField.text.length);
        // textField.text = leftFromCursor + result + rightFromCursor;
        // event.preventDefault();
    }

    // private static calcBiDiDisplay(str: string, html_str: string, textWidth: number, _direction: string = "rtl", dir: number = 1): any[] {
    //     //trace("calculating " + str + " " + html_str + " " + textWidth.toString())
    //     let text_analysis_array: any[] = new Array();
    //
    //     if (str == "") {
    //         return text_analysis_array;
    //     }
    //     let i: number;
    //     let format_str: string = "";
    //
    //     // go over the string and decide on types
    //     // types:
    //     //Left to right =L
    //     //Left to right =R
    //     //Weak types =W
    //     //Neutrals = N
    //     // to do - add NSM (non spacing marks on unicode)
    //
    //     let text_types: string = "";
    //     let j = 0;
    //
    //     for (j; j < str.length; j++) {
    //         i = str.charCodeAt(j);
    //
    //         if (i == 32 || i == 10 || i == 12 || i == 13) { //space
    //             text_types += "N";
    //         }
    //
    //         if (str.charAt(j).indexOf("°$¢£%€₤₧₣₪") != -1) {
    //             text_types += "T";
    //         }
    //         else {
    //             if ((i >= 33 && i <= 47) || (i >= 58 && i <= 64) || (i >= 91 && i <= 96)) { // punc
    //                 text_types += "W";
    //             }
    //         }
    //
    //         if ((i >= 48 && i <= 57) || (i >= 1632 && i <= 1641)) { // numbers & arabic numbers
    //
    //             text_types += "D";
    //         }
    //
    //         if (i >= 65 && i <= 122) {
    //             text_types += "L";
    //         }
    //
    //         if ((i >= 1488 && i <= 1631) || (i >= 1642 && i <= 1790) || (i >= 64285 && i <= 65276)) {
    //             text_types += "R";
    //         }
    //
    //         // all others are strongly typed left - to do - make this exact
    //         if (text_types.length != j + 1) {
    //             text_types += "L";
    //         }
    //
    //     }
    //     // create word array
    //     let word_array: any[] = new Array();
    //     let prevType: string = text_types.charAt(0);
    //     let curWord: any = "";
    //     let curWordFormat: string = "";
    //     let wordCount: number = 0;
    //     let curType: string;
    //
    //     for (j = 0; j < str.length; j++) {
    //         curType = text_types.charAt(j);
    //
    //         if (curType != prevType) {
    //
    //             word_array.push(new Word((<String>curWord), prevType, wordCount, curWordFormat));
    //             prevType = curType;
    //             curWord = str.charAt(j);
    //             curWordFormat = format_str.charAt(j);
    //             wordCount++;
    //         }
    //         else {
    //
    //             curWord += str.charAt(j);
    //             curWordFormat += format_str.charAt(j);
    //         }
    //     }
    //
    //     if (curWord != "") {
    //         word_array.push(new Word((<String>curWord), prevType, wordCount, curWordFormat));
    //     }
    //     // *************** sort words *************
    //     prevType = "";
    //     // first handle weaks
    //     let parType: string = (dir == -1) ? "R" : "L";
    //
    //     for (i = 0; i < word_array.length; i++) {
    //         curWord = word_array[i];
    //         curType = curWord.type;
    //
    //         switch (curType) {
    //             // W1-3 todo - handle Arabic Numbers
    //             // W4. A single European separator between two European numbers changes to a European number. A single common separator between two numbers of the same type changes to that type.
    //             //W6. Otherwise, separators and terminators change to Other Neutral.
    //             case "W":
    //
    //                 if (i == word_array.length - 1 || i == 0) {
    //
    //                     curWord.type = parType;
    //                     curType = parType;
    //                 }
    //                 else {
    //                     if (word_array[i - 1].type == "D" && word_array[i + 1].type == "D") {
    //                         curWord.type = "D";
    //                         curType = "D";
    //                     }
    //                     else {
    //                         curWord.type = "N";
    //                         curType = "N";
    //                     }
    //                 }
    //                 break;
    //             case "T":
    //                 //W5. A sequence of European terminators adjacent to European numbers changes to all European numbers.
    //                 //W6. Otherwise, separators and terminators change to Other Neutral.
    //                 if (word_array[i - 1].type == "D") {
    //                     curWord.type = "D";
    //                     curType = "D";
    //                 }
    //                 else {
    //                     curWord.type = "N";
    //                     curType = "N";
    //                 }
    //                 break;
    //
    //         }
    //     }
    //     //W7. Search backward from each instance of a European number until the first strong type (R, L, or sor) is found. If an L is found, then change the type of the European number to L.
    //     let curStrong: string = parType;
    //
    //     for (i = 0; i < word_array.length; i++) {
    //         curWord = word_array[i];
    //         curType = curWord.type;
    //
    //         if (curType == "L") {
    //             curStrong = "L";
    //         }
    //
    //         if (curType == "R") {
    //             curStrong = "R";
    //         }
    //
    //         if (curStrong == "L" && curType == "D") {
    //             curWord.type = "L";
    //         }
    //     }
    //
    //     //N1. A sequence of neutrals takes the direction of the surrounding strong text if the text on both sides has the same direction. European and Arabic numbers act as if they were R in terms of their influence on neutrals. Start-of-level-run (sor) and end-of-level-run (eor) are used at level run boundaries.
    //     for (i = 0; i < word_array.length; i++) {
    //
    //         curWord = word_array[i];
    //
    //         curType = curWord.type;
    //
    //         if (curType == "N") {
    //             if (word_array[i - 1].type == word_array[i + 1].type) {
    //                 curWord.type = word_array[i - 1].type;
    //             }
    //             else {
    //                 //N2. Any remaining neutrals take the embedding direction.
    //
    //                 curWord.type = parType;
    //             }
    //         }
    //     }
    //     //setting up embeding levels and dividing into lines(currently not done)
    //     let curLine_array: any[] = new Array();
    //     let measure_txt: TextField = new TextField();
    //     //measure_txt.defaultTextFormat =this.my_fmt
    //     prevType = word_array[0].type;
    //     let EL: number = (prevType == "L") ? 0 : 1;
    //     measure_txt.wordWrap = false;
    //     measure_txt.multiline = false;
    //
    //     if (_direction == "ltr") {
    //         measure_txt.autoSize = "left";
    //     }
    //     else {
    //         measure_txt.autoSize = "right";
    //     }
    //     measure_txt.text = "";
    //     measure_txt.width = 0;
    //
    //     for (i = 0; i < word_array.length; i++) {
    //         curWord = word_array[i];
    //         curType = curWord.type;
    //
    //         //setting embeding levels
    //         if (curType != prevType) {
    //             switch (curType) {
    //                 case "R":
    //                     EL += 1;
    //                     break;
    //                 case "D":
    //                     if (prevType == "R") {
    //                         EL += 1;
    //                     }
    //                     else {
    //                         EL += 2;
    //                     }
    //                     break;
    //                 case "L":
    //                     if (prevType == "R") {
    //                         EL += 1;
    //                     }
    //                     break;
    //             }
    //
    //             prevType = curType;
    //         }
    //         curWord.EL = EL;
    //
    //         // breaking lines
    //
    //         // if (#<{(|this._multiline|)}>#true)
    //         if (true) {
    //             measure_txt.appendText(curWord.text);
    //
    //             // to do - add line break characters
    //             // the +15 is for safty reasons. I cant get rid of a 5px margin the text has...
    //             if (measure_txt.width >= textWidth) {
    //                 let tempIndex: number = curLine_array.length - 1;
    //                 let temp_array: any[] = new Array();
    //                 measure_txt.text = "";
    //                 measure_txt.width = 0;
    //
    //                 // go back and find the last space to warp on
    //                 while (tempIndex > 0 && curLine_array[tempIndex].text != " ") {
    //                     temp_array.push(curLine_array.pop());
    //                     measure_txt.appendText(temp_array[temp_array.length - 1].text);
    //                     tempIndex = curLine_array.length - 1;
    //                 }
    //                 text_analysis_array.push(curLine_array);
    //                 curLine_array = temp_array.slice(0);
    //                 curLine_array.push(curWord);
    //                 measure_txt.text = curWord.text;
    //             }
    //             else {
    //
    //                 curLine_array.push(curWord);
    //             }
    //
    //         }
    //     }
    //     text_analysis_array.push(curLine_array);
    //
    //     // finally reverse what is needed to create the final text:
    //
    //     // L1. On each line, reset the embedding level of the following characters to the paragraph embedding level:
    //
    //     // 1.Segment separators,
    //     // 2.Paragraph separators,
    //     // 3. Any sequence of whitespace characters preceding a segment separator or paragraph separator, and
    //     // 4. Any sequence of white space characters at the end of the line.
    //     // (only item 4 is applied)
    //     //L2. reverse any contiguous sequence of characters that are at that level or higher.
    //
    //     for (j = 0; j < text_analysis_array.length; j++) {
    //         let curLine: any = text_analysis_array[j];
    //         curLine.segments = new Array();
    //         curLine.formatSegments = new Array();
    //         let curEL: number = curLine[0].EL;
    //         let curText: string = "";
    //         let curFormat: string = "";
    //
    //         for (i = 0; i < curLine.length; i++) {
    //             if (curLine[i].EL != curEL) {
    //                 if (curEL % 2 == 0) {
    //                     curLine.segments.push(curText);
    //                     curLine.formatSegments.push(curFormat);
    //                 }
    //                 else {
    //                     curLine.segments.push(TextFieldHelper.reverse(curText));
    //                     curLine.formatSegments.push(TextFieldHelper.reverse(curFormat));
    //                 }
    //                 curText = curLine[i].text;
    //                 curFormat = curLine[i].format;
    //             }
    //             else {
    //                 curText += curLine[i].text;
    //                 curFormat += curLine[i].format;
    //             }
    //
    //             curEL = curLine[i].EL;
    //         }
    //
    //         if (curEL % 2 == 0) {
    //             curLine.segments.push(curText);
    //             curLine.formatSegments.push(curFormat);
    //         }
    //         else {
    //             curLine.segments.push(TextFieldHelper.reverse(TextFieldHelper.manageBrackets(curText)));
    //             curLine.formatSegments.push(TextFieldHelper.reverse(curFormat));
    //         }
    //
    //         if (dir == -1) {
    //             curLine.segments.reverse();
    //             curLine.formatSegments.reverse();
    //         }
    //
    //     }
    //     return text_analysis_array;
    //     // just tracing
    //
    //     //trace (this._text)
    //     //trace (text_types)
    //     //trace(word_array.length)
    //
    // }

    /***
     *   checks if textfield has spaces - linebreaks or other symbols which may justify a multiline label
     *   if not sets the textfield to multiline/wordwrap false,
     *   to avoid splitting text on multines with no respect
     *   for syllables
     * @param textField
     * @param text
     */
    public static adjustUnwantedMultilineLabels(textField: TextField, text: string): void {
        if (text.indexOf(" ") == -1 && text.indexOf("\n") == -1 && text.indexOf("-") == -1) {
            //  forcing numlines to 1 in order to get the text scaled and not truncated,
            // since there are no line breaks, splits or spaces in the text that will allow a safe and correct spelling on two lines
            textField.multiline = false;
            textField.wordWrap = false;
        }
    }

    public static replace(theText: string, searchText: string, replaceText: string): string {
        theText = theText.split(searchText).join(replaceText);
        return (theText);
    }

    public static manageBrackets(textToSet: string): string {
        // todo - optimize
        textToSet = TextFieldHelper.replace(textToSet, ")", "^1^");
        textToSet = TextFieldHelper.replace(textToSet, "(", "^2^");
        textToSet = TextFieldHelper.replace(textToSet, "^1^", "(");
        textToSet = TextFieldHelper.replace(textToSet, "^2^", ")");
        textToSet = TextFieldHelper.replace(textToSet, "]", "^1^");
        textToSet = TextFieldHelper.replace(textToSet, "[", "^2^");
        textToSet = TextFieldHelper.replace(textToSet, "^1^", "[");
        textToSet = TextFieldHelper.replace(textToSet, "^2^", "]");
        textToSet = TextFieldHelper.replace(textToSet, "}", "^1^");
        textToSet = TextFieldHelper.replace(textToSet, "{", "^2^");
        textToSet = TextFieldHelper.replace(textToSet, "^1^", "{");
        textToSet = TextFieldHelper.replace(textToSet, "^2^", "}");
        textToSet = TextFieldHelper.replace(textToSet, ">", "^1^");
        textToSet = TextFieldHelper.replace(textToSet, "<", "^2^");
        textToSet = TextFieldHelper.replace(textToSet, "^1^", ">");
        textToSet = TextFieldHelper.replace(textToSet, "^2^", "<");
        return textToSet;
    }

    public static reverse(word_str: string): string {
        let revText: string = "";

        for (let i: number = 0; i < word_str.length; i++) {
            revText = word_str.charAt(i) + revText;
        }

        return revText;
    }

    public static changeFormat(textfield: TextField, size: any): void {
        let textFormat: TextFormat = textfield.getTextFormat();
        textFormat.size = size;
        textfield.setTextFormat(textFormat);
        textfield.defaultTextFormat = textFormat;
    }

    /**
     * Scales the TextField by increasing the font size (multiplying with scale factor),
     * as well as updating the dimensions (width & height), such that the bigger text can fit
     * 
     * @param textField 
     * @param scaleFactor 
     */
    public static scaleFontSizeAndDimensions(textField: TextField, scaleFactor: number): void {
        const f = textField.getTextFormat();
        textField.setTextFormat({ ...f, size: (f.size || 12) * scaleFactor });
        textField.height *= scaleFactor;
        textField.width *= scaleFactor;
    }
}


class Word {
    private _text: string;
    private _type: string;
    private _index: number;
    private _format: string;
    private _el: number;

    constructor(txt: string, typ: string, ind: number, frm: string) {
        this._text = txt;
        this._type = typ;
        this._index = ind;
        this._format = frm;
    }

    public get text(): string {
        return this._text;
    }

    public set text(t: string) {
        this._text = t;
    }

    public get type(): string {
        return this._type;
    }

    public set type(t: string) {
        this._type = t;
    }

    public get index(): number {
        return this._index;
    }

    public set index(t: number) {
        this._index = t;
    }

    public get format(): string {
        return this._format;
    }

    public set format(t: string) {
        this._format = t;
    }

    public get EL(): number {
        return this._el;
    }

    public set EL(t: number) {
        this._el = t;
    }
}
